import { render, staticRenderFns } from "./DetailsofTreatment.vue?vue&type=template&id=47ebabdf&"
import script from "./DetailsofTreatment.vue?vue&type=script&lang=js&"
export * from "./DetailsofTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports